export default "__VITE_ASSET__CewuQotX__"